import type { LandingComponents } from "@/puck/blocks/blockTypes";
import { ctaConfigs } from "@/puck/blocks/marketing/ctaConfigs";
import { heroConfigs } from "@/puck/blocks/marketing/heroConfigs";
import { oneGailConfigs } from "@/puck/blocks/marketing/oneGailConfigs";
import { proofConfigs } from "@/puck/blocks/marketing/proofConfigs";
import { structureConfigs } from "@/puck/blocks/marketing/structureConfigs";
import { gptPageMockupConfigs } from "@/puck/blocks/marketing/gptPageMockupConfigs";
import { aiModelsConfigs } from "@/puck/blocks/marketing/aiModelsConfigs";

/** Component names for the bespoke marketing page sections (the `Lp*` family). */
export type MarketingBlockName =
  | "LpHero"
  | "LpGptHero"
  | "LpFeatureStrip"
  | "LpReframe"
  | "LpHowItWorks"
  | "LpWorkflows"
  | "LpOneGail"
  | "LpIntegrations"
  | "LpOutcomes"
  | "LpBuyerQuote"
  | "LpHonestFilter"
  | "LpFaq"
  | "LpBookDemo"
  | "LpGptBottomCta"
  | "LpGptPageMockup"
  | "LpAiModels"
  | "LpFooter";

export const marketingBlocks: Pick<LandingComponents, MarketingBlockName> = {
  ...heroConfigs,
  ...structureConfigs,
  ...oneGailConfigs,
  ...proofConfigs,
  ...gptPageMockupConfigs,
  ...aiModelsConfigs,
  ...ctaConfigs,
};
